/** @format */

export const PRODUCT_RESULTS_PER_PAGE = 8;

export const PRODUCT_FACET_FIELDS = [
    'product_condition_star_rating',
    'product_price',
    '*',
];

export const PRODUCT_SORT_OPTIONS = [
    { value: 'price_high_low', facet: 'product_price', direction: 'DESC' },
    { value: 'price_low_high', facet: 'product_price', direction: 'ASC' },
    {
        value: 'product_last_online',
        facet: 'product_last_online',
        direction: 'DESC',
    },
] as const;
